import { Expense } from "@finway-group/shared/lib/models"
import React from "react"
import MainDetailsSectionComponent from "./mainDetailsSection.component"
import MainDetailsSectionContext from "./mainDetailsSection.context"

interface MainDetailsSectionWrapperProps {
    expense: Expense
    isMinimized?: boolean
    openEditModal?: () => void
    setIsExpenseUpdating?: React.Dispatch<React.SetStateAction<boolean>>
    showProbability?: boolean
    showLink?: boolean
    setIsShowingDiscountForm?: React.Dispatch<React.SetStateAction<boolean>>
}
const MainDetailsSectionWrapper = ({
    expense,
    isMinimized = false,
    openEditModal,
    setIsExpenseUpdating,
    setIsShowingDiscountForm,
    showProbability = false,
    showLink = false,
}: MainDetailsSectionWrapperProps) => (
    <MainDetailsSectionContext
        expense={expense}
        isMinimized={isMinimized}
        setIsExpenseUpdating={setIsExpenseUpdating}
        openEditModal={openEditModal}
        showProbability={showProbability}
        showLink={showLink}
        setIsShowingDiscountForm={setIsShowingDiscountForm}
    >
        <MainDetailsSectionComponent />
    </MainDetailsSectionContext>
)

export default MainDetailsSectionWrapper
